import { useEffect, useState } from 'react'

import { useSessionDataService } from '@lib/hooks/services'

/**
 * Hook that provides session data (container ID and web session ID)
 * Uses SSR data as optimization but always fetches client-side for most current data
 */
export const useSessionData = () => {
  const sessionService = useSessionDataService()
  // Start with SSR data if available, but will be updated by client-side fetch
  const [containerId, setContainerId] = useState(() => sessionService.getContainerId() || '')
  const [websiteSessionId, setWebsiteSessionId] = useState(
    () => sessionService.getWebsiteSessionId() || '',
  )

  const containerIdPromise = sessionService.getContainerIdPromise()
  const websiteSessionIdPromise = sessionService.getWebsiteSessionIdPromise()

  useEffect(() => {
    // Always initialize client-side fetching to ensure we have the most current data
    sessionService.initializeClientSide()

    // Always listen for the container ID promise resolution
    // This will either be the SSR value (immediate) or client-side value (when fetched)
    containerIdPromise.then(id => {
      setContainerId(id)
    })

    // Always listen for the container ID promise resolution
    // This will either be the SSR value (immediate) or client-side value (when fetched)
    websiteSessionIdPromise.then(id => {
      setWebsiteSessionId(id)
    })
  }, [containerIdPromise, sessionService, websiteSessionIdPromise])

  return {
    containerId,
    websiteSessionId,
    containerIdPromise,
    websiteSessionIdPromise,
  }
}
